


























import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Emit } from 'vue-property-decorator';
import { getDate } from '@/modules/shared/shared/domain/functions/date-functions';

@Component({})
export default class ResumeListComponent extends Vue {
    @Prop({ type: Date, required: false })
    date?: string;
    @Prop({ type: String, required: false })
    number?: string;
    @Prop({ type: String, required: true })
    type?: 'bill' | 'health' | 'inform' | 'factura';
    @Prop({ type: String, required: true })
    name?: string;

    loading: boolean = false;

    @Emit()
    async openFile(file: string) {
        this.loading = true;
        await this.$emit('openFile', {
            fileName: file,
            done: () => {
                this.loading = false;
            },
        });
    }

    get reformatedDate() {
        return getDate('' + this.date).substring(5);
    }

    get isBill() {
        return this.type! === 'factura';
    }

    get isHealth() {
        return this.type! === 'health';
    }
}
